import { QuestionnaireResponseAttachment } from '../../AttachmentArbiter/Attachment';
import { createRenderingTracker, trackingKey } from '../createRenderingTracker';

/**
 * Why a tracker for questionnaire responses?
 * A single completed survey can be cited more than once in an impression
 * narrative. Each citation renders the same "Questionnaire response"
 * button, so the user ends up with a row of identical buttons that all
 * open the same survey. Identity is just the resource itself — there is
 * no per-page or per-question distinction at the citation level — so the
 * key is the FHIR `ResourceType/id`.
 */
export type QuestionnaireResponseTrackerInput = {
  attachment: QuestionnaireResponseAttachment;
};

const handle = createRenderingTracker<QuestionnaireResponseTrackerInput>(
  ({ attachment }) => trackingKey(attachment.identifier),
);

export const QuestionnaireResponseTrackingProvider = handle.Provider;
export const useQuestionnaireResponseTracker = handle.useTracker;
